import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from "@/Pages/Admin/Modules/Hotel/tab/Room/Package/Views/room-package.html";
import GeneralModule from "@/Pages/Admin/Modules/ManagePackage/Store/General";
import { trekService } from "@/Pages/Admin/Modules/ManagePackage/Services/Trekservice";
import { common } from "@/Pages/Admin/Modules/Common/Services/Common";
import ValidationError from "@/Pages/Admin/Modules/Common/Controllers/ValidationError";
import { flashService } from "@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService";
import { RoomPackageModel } from "@/Pages/Admin/Modules/Models/Hotel/RoomPackageModel";
import { ServiceModel } from "@/Pages/Admin/Modules/Models/Hotel/ServiceModel";
import { hotelService } from "@/Pages/Admin/Modules/Hotel/Services/HotelService";

@WithRender
@Component({
  components: {
    "validation-error": ValidationError,
  },
})
export default class RoomPackage extends Vue {
  protected ui: any = {};
  protected item: any = {};
  protected serviceData: any = [];

  constructor() {
    super();

    this.ui = {
      index: {
        edit: -1,
        delete: -1,
        up: 0,
        down: 0,
      },
      status: {
        isLoading: {
          getPcakageList: false,
          serviceList: false,
        },
        postLoading: {
          create: false,
          edit: false,
          delete: false,
        },
        canAdd: false,
        canEdit: false,
      },
      error: {
        errors: {},
        has_error: false,
        error_message: {},
        modal: {
          delete: {},
        },
      },
    };

    this.item = {
      packageList: new RoomPackageModel({}),
      addPackage: new RoomPackageModel({}),
      editPackage: new RoomPackageModel({}),
      deletePackage: new RoomPackageModel({}),
      tempPackage: new RoomPackageModel({}),
      serviceList: new ServiceModel({}),
    };
    this.serviceData = [];
  }

  public mounted() {
    this.getPackageList();
    this.serviceAllList();
  }

  public getPackageList() {
    let data = {
      hotel_id: this.$route.query.id,
      room_id: this.$route.query.rid,
    };
    this.ui.status.isLoading.getPackageList = true;
    hotelService
      .roomPackageList(data)
      .then((res: any) => {
        res.data.data.filter((list: any) => {
          list.IsActive = false;
        });
        this.item.packageList = res.data.data;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
          this.ui.error.has_error = true;
          this.ui.error.errors = res;
        });
      })
      .finally(() => {
        this.ui.status.isLoading.getPackageList = false;
      });
  }

  public serviceAllList() {
    this.ui.status.isLoading.serviceList = true;
    hotelService
      .serviceList()
      .then((res: any) => {
        this.item.serviceList = res.data.data.data;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.error_message).then((res) => {
          this.ui.error.has_error = true;
          this.ui.error.error_message = res;
        });
      })
      .finally(() => {
        this.ui.status.isLoading.serviceList = false;
      });
  }

  protected addPackage() {
    this.resetError();

    if (!this.validateAddPackageAction()) {
      return;
    }

    let data = {
      hotel_id: this.$route.query.id,
      room_id: this.$route.query.rid,
      title: this.item.addPackage.title,
      price: this.item.addPackage.price,
      servicesId: this.serviceData,
    };
    console.log(data);
    this.ui.status.postLoading.create = true;
    hotelService
      .addRoomPackage(data)
      .then((res: any) => {
        this.item.packageList.unshift(res.data.data);
        flashService.Success("Package Added", res.data.message);
        this.ui.status.canAdd = false;
        this.resetError();
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.error_message).then((res) => {
          this.ui.error.error_message = res;
        });
      })
      .finally(() => {
        this.ui.status.postLoading.create = false;
      });
  }

  protected validateAddPackageAction() {
    let list = this.item.addPackage;
    if (!list.title) {
      Object.assign(this.ui.error.errors, {
        title: ["The title field is required."],
      });
    }

    if (!list.price) {
      Object.assign(this.ui.error.errors, {
        price: ["The price field is required."],
      });
    }

    if (common.notEmpty(this.ui.error.errors)) {
      this.ui.error.has_error = true;
      return false;
    } else {
      return true;
    }
  }

  protected onEditPackageClick(index: number, list: any) {
    this.resetError();
    this.ui.status.canEdit = true;
    this.item.tempPackage = Object.assign({}, list);
    this.ui.index.edit = index;
    list.IsActive = true;
    this.item.editPackage = list;
  }

  protected editPackage() {
    // this.resetError();

    // if (!this.validateEditPackageAction()) {
    //   return;
    // }
    let data = {
      hotel_id: this.$route.query.id,
      room_id: this.$route.query.rid,
      id: this.item.editPackage.id,
      title: this.item.editPackage.title,
      price: this.item.editPackage.price,
      servicesId: this.serviceData,
    };
    this.ui.status.postLoading.edit = true;
    hotelService
      .addRoomPackage(data)
      .then((res: any) => {
        this.ui.status.canEdit = false;
        this.$set(this.item.includesList, this.ui.index.edit, res.data.data);
        flashService.Success("Include Edited", res.data.message);
        this.resetError();
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.error_message).then((res) => {
          this.ui.error.error_message = res;
        });
      })
      .finally(() => {
        this.ui.status.canEdit = false;
        this.ui.status.postLoading.edit = false;
      });
  }

  protected validateEditPackageAction() {
    let list = this.item.editInclude;
    if (!list.title) {
      Object.assign(this.ui.error.errors, {
        edit_title: ["The title field is required."],
      });
    }
    if (list.icon === null || list.icon.id === 0) {
      Object.assign(this.ui.error.errors, {
        edit_icon_id: ["The icon field is required."],
      });
    }
    if (common.notEmpty(this.ui.error.errors)) {
      this.ui.error.has_error = true;
      return false;
    } else {
      return true;
    }
  }

  protected cancelPackage(index: number, list: any) {
    this.resetError();
    this.ui.status.canEdit = false;
    list.IsActive = false;
    this.ui.index.edit = index;
    this.item.includesList[index] = this.item.tempInclude;
  }

  protected onDeletePackageClick(index: any, list: any) {
    this.resetError();
    this.ui.status.canEdit = false;
    $("#deleteSelectedIncludes").modal("show");
    this.ui.index.delete = index;
    this.item.deleteInclude = list;
  }

  protected deletePackage() {
    this.resetError();
    let data = {
      trek_id: this.$route.query.id,
      id: this.item.deleteInclude.id,
    };
    this.ui.status.postLoading.delete = true;
    trekService
      .deleteSelectedIncludes(data)
      .then((res: any) => {
        this.$delete(this.item.includesList, this.ui.index.delete);
        flashService.Success("Include Deleted", res.data.message);
        this.hideDeleteModal();
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.modal.delete).then((res) => {
          this.ui.error.modal.delete = res;
        });
      })
      .finally(() => {
        this.ui.status.postLoading.delete = false;
      });
  }

  protected hideDeleteModal() {
    $("#deleteSelectedIncludes").modal("hide");
    $(".modal-backdrop").remove();
    this.ui.error.modal.delete = {};
    this.resetError();
  }

  public resetError() {
    this.ui.error.errors = {};
    this.ui.error.has_error = false;
    this.ui.error.error_message = {};
  }

  public customLabel(name: any) {
    return name;
  }

  public get buttonTextAddPackage() {
    if (this.ui.status.postLoading.create) {
      return "Processing...";
    }
    return "Save Package";
  }

  protected showAddPackageButton() {
    this.ui.status.canAdd = true;
  }
}
